(function(angular){
	'use strict';
	
	angular
		.module('localRealEstateModule', [
			'campaignsModule', 
			'featuredPropertyListingModule',
			'reitElementListingModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);